import { PzoneCode } from './pzoneCode';

export class PzoneTrack {
    pzoneCode: string;
    timezone:string;
    trackName:string;
}